export const SAMSUNG_PAY = 'samsungPay';
export const CREDIT_CARD = 'creditCard';
export const GOOGLE_PAY = 'googlePay';
export const POINTS = 'points';
export const STORED_PAYMENT = 'storedPayment';
